import { serializable, alias, primitive } from 'serializr';

export class MultipleOriginsTransportation {
    @serializable
    id?: number;

    @serializable(alias('product_raw_material_id', primitive()))
    productRawMaterialId?: number;

    @serializable(alias('supplier_id', primitive()))
    supplierId?: number;

    @serializable
    type?: string;

    @serializable(alias('temperature_control', primitive()))
    temperatureControl?: string;

    @serializable(alias('transportation_air', primitive()))
    transportationAir?: boolean;

    @serializable
    supplier?: string;

    @serializable(alias('activity_label', primitive()))
    activityLabel?: string;

    @serializable
    createdAt?: string;

    @serializable
    updatedAt?: string;

    @serializable(alias('activity_mapping_region_spec_id', primitive()))
    activityMappingRegionSpecId?: string;

    @serializable
    origin?: string;

}